import script from "./VisibilityDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./VisibilityDropdown.vue?vue&type=script&setup=true&lang=js"

import "./VisibilityDropdown.vue?vue&type=style&index=0&id=08a38a48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a38a48"]])

export default __exports__